<template>
    <div>
        <a-drawer
                :title='title'
                :visible="visible"
                v-bind="drawerConfig"
                :body-style="{ paddingBottom: '80px' }"
                @close="onClose"
        >
            <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
                <a-form-model-item
                        ref="name"
                        label="功能名称"
                        prop="name"
                        :help="formErr.name"
                        :validateStatus='!formErr.name||formErr.name==""?"":"error"'
                >
                    <a-input
                            :maxLength=20
                            v-model="form.name"
                            @change="(e) => { formErr.name=''}"
                            @blur="(e) => {  form.name = e.target.value.trim();formErr.name='' }"
                    />
                </a-form-model-item>
              <a-form-model-item
                  ref="title"
                  label="引导语标题"
                  prop="title"
                  :help="formErr.title"
                  :validateStatus='!formErr.title||formErr.title==""?"":"error"'
              >
                <a-input
                    :maxLength=100
                    v-model="form.title"
                    @change="(e) => { formErr.title=''}"
                    @blur="(e) => {  form.title = e.target.value.trim();formErr.title='' }"
                />
              </a-form-model-item>
              <a-form-model-item
                  ref="description"
                  label="引导语描述"
                  prop="description"
                  :help="formErr.description"
                  :validateStatus='!formErr.description||formErr.description==""?"":"error"'
              >
                <a-input
                     type="textarea"
                     :maxLength=200
                    v-model="form.description"
                    @change="(e) => { formErr.description=''}"
                    @blur="(e) => {  form.description = e.target.value.trim();formErr.description='' }"
                />
              </a-form-model-item>

              <a-form-model-item v-show="this.$route.query.id != 1" label="指令词">{{form.word||'用户描述'}}</a-form-model-item>
              <a-form-model-item
                  ref="content"
                  label="指令内容"
                  prop="content"
                  :help="formErr.content"
                  :validateStatus='!formErr.content||formErr.content==""?"":"error"'
              >
                <a-input
                    type="textarea"
                    v-model="form.content"
                    @change="(e) => { formErr.content=''}"
                    @blur="(e) => {  form.content = e.target.value.trim();formErr.content='' }"
                />
              </a-form-model-item>
              <a-form-model-item
                  ref="remark"
                  label="备注内容"
                  prop="remark"
                  :help="formErr.remark"
                  :validateStatus='!formErr.remark||formErr.remark==""?"":"error"'
              >
                <a-input
                    type="textarea"
                    v-model="form.remark"
                    @change="(e) => { formErr.remark=''}"
                    @blur="(e) => {  form.remark = e.target.value.trim();formErr.remark='' }"
                />
              </a-form-model-item>
            </a-form-model>
            <div class="drawer-btn">

                <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                    确定
                </a-button>
                <a-button @click="onClose">
                取消
            </a-button>
            </div>
        </a-drawer>
    </div>
</template>

<script>
    import {submitForm, drawerConfig, validator} from "../../../../../../../../utils/utils"
    import API from "../api";

    export default {
        name: "colorForm",
        props: ["visible", "title", "editId"],
        data() {
            return {
                drawerConfig,
                role: [],
                form: {
                  name: "",
                  title:'',
                  description:'',
                  content:'',
                  remark:'',
                  id:'',
                },
                formErr: {
                  name: "",
                  title:'',
                  description:'',
                  content:'',
                  remark:'',
                  id:'',
                },
                rules: {
                    name: [{required: true, message: "请输入功能名称 ", trigger: "blur"} ],
                  title: [{required: true, message: "请输入引导语标题 ", trigger: "blur"} ],
                  content: [{required: true, message: "请输入指令内容 ", trigger: "blur"} ],

                },
                layout: {
                    labelCol: {span: 4},
                    wrapperCol: {span: 14},
                },
            };
        },
        watch: {
            editId: function (a, b) {
                if (a != "") {
                    API.service.EDIT_DATA(a).then(res => {
                        this.form = res.data.data
                        this.form.id = a
                      this.rules.content=[{required: true, message: "请输入指令内容 ", trigger: "blur"} ]
                    })
                } else {
                    this.form.id = ''
                  this.rules.content=[{required: false, message: "请输入指令内容 ", trigger: "blur"} ]
                }
            }
        },
        mounted() {
        },
        methods: {
            onClose() {
                this.$emit("changVisible", false);
                this.formErr = {  name: "",
                  title:'',
                  description:'',
                  content:'',
                  remark:'',
                  word:'',
                  id:'',}
                this.$refs.ruleForm.resetFields();
            },
            onSubmit() {
                let _this = this;
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        this.form.id == '' || this.form.id == undefined ? url = API.service.SUBMIT_ADD : url = API.service.SUBMIT_EDIT
                      if( this.form.id == '' || this.form.id == undefined){
                        _this.form.a_ai_assistant_id=_this.$route.query.id
                      }
                      url( _this.form).then(res => {
                            if (res.data.code == 200) {
                            this.$message.success(res.data.msg);
                            this.onClose()
                            } else {
                              console.log("res",res)
                                res.data.data.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>

</style>
